export const vatTranslationsEn = {
  vat: {
    fields: {
      taxCategory: 'Tax category',
      exempt: 'VAT exempt',
      rate: 'VAT rate (%)',
      reason: 'Exemption reason',
      number: 'VAT number',
    },
    categories: {
      Normal: 'Normal',
      Intermediate: 'Intermediate',
      Reduced: 'Reduced',
      Exempt: 'Exempt',
      Other: 'Other',
    },
    help: {
      exempt: 'Exempt items do not need a VAT rate. The reason is optional.',
      rate: 'Enter a percentage greater than 0 and up to 100.',
      number: 'Optional. For a store in Portugal, use a valid 9-digit NIF.',
    },
    validation: {
      rateRequired: 'Enter a VAT rate greater than 0 and up to 100.',
    },
  },
};

export const vatTranslationsPt = {
  vat: {
    fields: {
      taxCategory: 'Categoria de IVA',
      exempt: 'Isento de IVA',
      rate: 'Taxa de IVA (%)',
      reason: 'Motivo da isenção',
      number: 'NIF',
    },
    categories: {
      Normal: 'Normal',
      Intermediate: 'Intermédia',
      Reduced: 'Reduzida',
      Exempt: 'Isenta',
      Other: 'Outra',
    },
    help: {
      exempt: 'Os itens isentos não precisam de taxa de IVA. O motivo é opcional.',
      rate: 'Indique uma percentagem maior que 0 e até 100.',
      number: 'Opcional. Para uma loja em Portugal, use um NIF válido com 9 dígitos.',
    },
    validation: {
      rateRequired: 'Indique uma taxa de IVA maior que 0 e até 100.',
    },
  },
};

export const vatTranslationsEs = {
  vat: {
    fields: {
      taxCategory: 'Categoría de IVA',
      exempt: 'Exento de IVA',
      rate: 'Tipo de IVA (%)',
      reason: 'Motivo de la exención',
      number: 'NIF',
    },
    categories: {
      Normal: 'Normal',
      Intermediate: 'Intermedia',
      Reduced: 'Reducida',
      Exempt: 'Exenta',
      Other: 'Otra',
    },
    help: {
      exempt: 'Los artículos exentos no necesitan tipo de IVA. El motivo es opcional.',
      rate: 'Indique un porcentaje mayor que 0 y hasta 100.',
      number: 'Opcional. Para una tienda en Portugal, use un NIF válido de 9 dígitos.',
    },
    validation: {
      rateRequired: 'Indique un tipo de IVA mayor que 0 y hasta 100.',
    },
  },
};
